module.exports = __webpack_public_path__ + "img/close-x-black.a5cdcb6.svg";